import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { BetBuilderPicksCard } from "./components";

import { useRootAppStore } from "@hooks";

import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import { HubState } from "@gp/hub";
import { analyticsTracker } from "@utils/analytics";
import BetBuilderPicksFilterBar from "./components/BetBuilderPicksFilterBar";
import QuickPlayPageContentLoader from "../common/QuickPlayPageContentLoader";

import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPicksPage() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	useScrollRestoration({ type: ConfigType.Basic });

	if (
		rootStore.betBoosterHubStore.connectionState == HubState.CONNECTING ||
		rootStore.quickPlayStore.shouldShowLoader
	) {
		return (
			<div className="section--quick">
				<QuickPlayPageContentLoader />
			</div>
		);
	}

	if (rootStore.quickPlayStore.shouldShowEmptyState) {
		return (
			<div className="section--quick">
				<div className="card">
					<InfoMessageComponent
						type="note"
						message={t(
							"QUICK_PLAY.BET_BUILDER_PICKS.PICKS_EMPTY_STATE"
						)}
					/>
				</div>
			</div>
		);
	}

	return (
		<div className="section--quick">
			<div className="section">
				<BetBuilderPicksFilterBar />
				{rootStore.quickPlayStore.betBoosterStore.hubData.betBuilderPresetIds.map(
					(item, index) => {
						const slip =
							rootStore.quickPlayStore.betBuilderPicksStore.BBPicks.get(
								item
							);

						if (!slip) {
							return null;
						}

						const event =
							rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
								slip.eventId
							);

						return (
							<div
								key={slip.id}
								className="card card--qp card--qp--nowrap card--bbp card--bbp--nowrap"
								onClick={() => {
									analyticsTracker.trackQuickPlayInteraction(
										BetBuilderPickActionsTypeEnum.PickClick
									);
									rootStore.quickPlayStore.betBuilderPicksStore.activatePopup(
										slip.id,
										index,
										true
									);
								}}
							>
								<div className="card__header card--qp__header card--bbp__header">
									{/* <i className="u-icon u-icon--base u-icon--bb--active" /> */}

									<QuickPlayEventResultAndTime
										event={event}
										startTime={slip.startTime}
										isTextInline
									/>

									{slip.isLive && (
										<span className="card--qp__tag tag tag--tny tag--live--ghost tag--bolder">
											{t<string>("COMMON.LIVE")}
										</span>
									)}
								</div>

								<div className="card__body card--qp__body card--bbp__body">
									<BetBuilderPicksCard
										BBPick={slip}
										maxOffers={3}
										key={slip.id}
									/>
								</div>
							</div>
						);
					}
				)}
			</div>
		</div>
	);
});
